<template>
    <div class="direct-rent">
        <NavComponent :index="2"></NavComponent>
        <!-- <div class="banner" v-bind:style="{backgroundImage:'url('+banner+')'}"> -->
        <div class="banner" >
            <el-image v-show="activeIndex == 0" :src="banner" fit="cover"></el-image>
            <div v-for="(item,index) in searchList.city" :key="index">
                <el-image v-show="activeIndex != 0 && activeIndex == index" :src="item.banner" fit="cover"></el-image>
            </div>
        </div>
        <div class="rent-bg" ref="rent">
            <div class="content-container rent-top">
                <div class="search-item">
                    <input class="search-input" v-model="pages.keyword" placeholder="请输入公寓名字"/>
                    <div class="search" @click="getSearch" v-bind:style="{backgroundImage:'url('+ search_icon +')'}"></div>
                    <!-- <div class="search look-map" @click="goMapPage()"><img class="maker" :src="maker_icon"/><span>查看地图</span></div> -->
                </div>
            </div>
            <div class="content-container search-list">
                <div class="search-list-item">
                    <div class="item-name">城市：</div>
                    <ul>
                        <li v-for="(item,index) in searchList.city" @click="searchCondition(item.id,'city',item.banner,index)" :key="item.id" v-bind:class="[item.id == pages.city ? 'active' : '']">{{item.name}}</li>
                    </ul>
                </div>
                <div class="search-list-item" v-if="cityareaList.length != 0">
                    <div class="item-name">区域：</div>
                    <ul>
                        <li v-for="(item) in cityareaList" :key="item.id" @click="searchCondition(item.id,'cityarea')" v-bind:class="[item.id == pages.cityarea ? 'active' : '']">{{item.name}}</li>
                    </ul>
                </div>
                <div class="search-list-item">
                    <div class="item-name">居室：</div>
                    <ul>
                        <li v-for="(item) in searchList.bedrooms" :key="item.id" @click="searchCondition(item.id,'bedrooms')" v-bind:class="[item.id == pages.bedrooms ? 'active' : '']">{{item.name}}</li>
                    </ul>
                </div>
                <div class="search-list-item">
                    <div class="item-name">类型：</div>
                    <ul>
                        <li v-for="(item) in searchList.housetype" :key="item.id" @click="searchCondition(item.id,'housetype')" v-bind:class="[item.id == pages.housetype ? 'active' : '']">{{item.name}}</li>
                    </ul>
                </div>
            </div>
        </div>
        <Loading v-if="LOADING" class="loading-component"></Loading>
        <div v-else class="content-container rentList">
            <div class="list-header">
                <div>推荐排序</div>
                <div><span> {{houseInfo.total}} </span>个公寓 </div>
            </div>
            <div v-if="houseInfo.data.length != 0">
                <RentListComponent v-for="(item) in houseInfo.data" :item = item :key="item.id"></RentListComponent>
            </div>
            <div class="list-item" v-if="houseInfo.data.length == 0">未搜索到相关公寓</div>
        </div>
        <el-pagination class="pagination" background layout="prev, pager, next" prev-text="上一页" next-text="下一页" :pagerCount="5"  :total="houseInfo.total"  @current-change="handleCurrentChange">

        </el-pagination>
        <div class="rent-bottom">
            <h4>选择汉伦管家的理由</h4>
            <ul class="bottom-list content-container">
                <li v-for="(item) in bottomList" :key="item.name">
                    <img class="img-icon" :src="item.url" />
                    <div class="title">{{item.name}}</div>
                    <p>{{item.content}}</p>
                </li>
            </ul>
        </div>
        <SideBarComponent></SideBarComponent>
        <FooterComponent></FooterComponent>
    </div>
</template>
<script>
import FooterComponent  from '@components/FooterComponent'
import NavComponent  from '@components/NavComponent'
import SideBarComponent from '@components/SideBarComponent'
import RentListComponent from '@components/RentListComponent'

import bottom_icon1 from '@assets/image/rent/bottom-icon1.png'
import bottom_icon2 from '@assets/image/rent/bottom-icon2.png'
import bottom_icon3 from '@assets/image/rent/bottom-icon3.png'
import bottom_icon4 from '@assets/image/rent/bottom-icon4.png'
import search_icon from '@assets/image/rent/search_icon.png'
import maker_icon from '@assets/image/rent/maker_icon.png'

export default {
    name: 'DirectRentPage',
    computed:{
        
    },
    components: {
        FooterComponent,
        NavComponent,
        SideBarComponent,
        RentListComponent
    },
    data(){
        return {
            search_icon,maker_icon,
            searchList:{},
            houseInfo:{
                data:[]
            },
            activeIndex:0,
            LOADING:false,
            banner:'https://cdn.hanlandglobal.com/rent-banner.jpg',
            cityareaList:[],
            pages:{
                page:1,
                city:0,
                cityarea:0,
                school:0,
                architecture:0,
                bedrooms:0,
                housetype:0,
                keyword:''
            },
            bottomList:[
                {url:bottom_icon1,name:'24小时监控',content:'安全有保障，入住更舒心'},
                {url:bottom_icon2,name:'专业维修',content:'设施有故障，系统上门修'},
                {url:bottom_icon3,name:'光纤网络',content:'高速路由器，wifi全覆盖'},
                {url:bottom_icon4,name:'双语服务',content:'团队多元化，沟通零距离'},
            ],              
        }
    },
    mounted(){
        this.getHouseList()
        this.getSearchList()
    },
    methods:{
        getHouseList(){
            var that = this
            this.LOADING = true
            this.axios.get(this.url+'/api/house/keeper',{params:this.pages}).then(function(response){
                that.LOADING = false
                that.houseInfo  = response.data.data
            }).catch(function() {
            });
        },
        getSearchList(){
            var that = this
            this.axios.get(this.url+'/api/house/conditions',{}).then(function(response){
                that.searchList = response.data.data
            }).catch(function() {
            });
        },
        goMapPage(){
             this.$router.push('/mapDetdil')
        },
        handleCurrentChange(val){
            this.pages.page = val
            this.getHouseList();
            this.$refs.rent.scrollIntoView({behavior: "instant"});
        },
        searchCondition(id,name,banner,index){
            this.pages[name] = id
            this.activeIndex = index
            // banner && (this.banner = banner)
            if(index){
                console.log(index)
                this.pages.cityarea = '';
                this.pages.bedrooms = '';
                this.pages.housetype = '';
                this.cityareaList = this.searchList.city[index].area
            }
            if(index == 0){
                this.pages.cityarea = '';
                this.cityareaList = []
            }
            this.getHouseList()        
        },
        getSearch(){
            this.getHouseList()
        },
    }

}
</script>
<style lang="scss" scoped>
.rent-bg{
    background: #f3f3f3;
    padding:2.5rem 0;
}
.banner{
    width: 100%;
    height: 100%;
}
.search-item{
    display: flex;
    .search-input{
        width: 51rem;
        text-indent: 1rem;
        font-size: 0.8rem;
        color: $font;
        border: none;
    }
    .search-input:focus{
        outline:none;
    }
    .search{
        width: 8rem;
        height: 2.6rem;
        background-color: #0e2d57;
        border-radius: 4px;
        background-repeat: no-repeat;
        background-position: center;
        background-size: 1.6rem 1.6rem;
    }
    .look-map{
        width: 13rem;
        display: flex;
        align-items: center;
        justify-content:center;
        margin-left: 1rem;
        color: #fff;
        cursor: pointer;
        .maker{
            width: 1.4rem;
            height: 1.7rem;
            margin-right: 1rem;
        }
    }
}
.search-list{
    height: auto;
    background: #fff;
    margin-top: 1rem;
    padding:1.5rem 0rem .5rem 2.2rem;
    .search-list-item{
        margin-bottom: 1rem;
        font-size: 0.9rem;
        letter-spacing: 0px;
        color: #0e2d57;
        display: flex;
    }
    .item-name{
        margin-right: 0.4rem;
    }
    .active{
        background-color: #0e2d57;
        border-radius: 4px;
        color: #fff;
    }
    ul{
        width: 45rem;
        display: flex;
        flex-wrap: wrap;
        li{
            margin-left: 1rem; 
            font-size: 0.9rem;
            padding: 0 0.8rem;
            line-height: 1.4rem;
            color: #999999;
            margin-bottom: 0.4rem;
            cursor: pointer;
        }
    }
}
.rent-bottom{
    text-align: center;
    padding-bottom: 5rem;
    h4{
        font-size: 1.4rem;
        font-weight: normal;
        font-stretch: normal;
        padding: 2.5rem 0;
        font-weight: 700;
        letter-spacing: 2px;
        color: $color;
    }
    ul{
        display: flex;
        justify-content: space-around;
        li{
          .title{
            font-size: 1.2rem;
            line-height: 2.4rem;
            color: $color;
          }
          p{
            font-size: 1rem;
            color: $font; 
          }  
        }
    }
}
.list-header{
    margin-top: 3rem;
    border-bottom: solid 0.2rem #0e2d57;
    display: flex;
    justify-content:space-between;
    color: $font;
    line-height: 1.6rem;
    span{
        color: $color;
        font-weight: 700;
    }
}
.pagination{
    width: 27.5rem;
    margin: 2.5rem auto;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
}
.list-item{
    min-height: 20rem;
    color: $font;
    text-align: center;
    line-height: 5rem;
}
.img-icon{
    width: 5.2rem;
    height: 6rem;
}
@media only screen and (max-width: 1024px){
    .banner{
        height: 18.2rem;
        background-size: cover;
    }
    .rent-top{
        padding: 0 3%;
    }
    .search-list{
        width: 94%;
        margin: 1rem auto 0;
        ul{
            width: 80%;
        }
    }
    .rentList{
        width: 100%;
        padding: 0 3%;
        .list-header{
            padding: 0 2%;
            margin-top: 1rem;
        }
        .list{
            width: 94%;
            margin: 0 auto;
            display: block;
            padding: 1rem 0;
        }
    }
    .pagination{
        width: 100%;
        margin-bottom: 1.5rem;
    }
       
}

</style>
<style lang="scss">
.banner .el-image{
    width: 100%;
    height: 100%;
}
@media only screen and (max-width: 1024px){
    .direct-rent{
        .el-pagination span{
            width: 6rem;
        }
        .el-pagination .btn-prev{
            width: 6rem;
            display: none;
        }
        .el-pagination .btn-next{
            width: 6rem;
            display: none;
        }
        .el-pagination .el-pager{
            margin: 0 1rem;
        }
    }
}
</style>